<template>
  <div>
    <world-nav/>

    <SvgPanZoom 
      :zoomEnabled="true"
      :fit="false"
      :center="false"
      class="map"
      maxZoom="2"
      @svgpanzoom="registerSvgPanZoom"
    >
      <svg class="rt" ref="mapFrame">
        <g>
          <defs>
            <marker id="mAr" markerWidth="5" markerHeight="10" refX="5" refY="2.5" orient="auto">
              <path d="M 0 0 5 2.5 0 5 Z" style="fill: #CCC;"/>
            </marker>            
          </defs>
          <template v-for="(node, key) in innerValue.area">
            <template v-for="(link, index) in node.link" >
              <line v-if="innerValue.area[link.to]" :key="key + index"
                :x1="node.x" :y1="node.y" 
                :x2="innerValue.area[link.to].x" :y2="innerValue.area[link.to].y"
                stroke="#CCC" stroke-width="5" marker-end="url(#mAr)"
              />
            </template>
          </template>
          <area-point v-for="(node, key) in innerValue.area" :key="key"
            :x="node.x" :y="node.y"
            :label="node.name"
            :value="key"
            @click="showDetail"
            :lv="node.lv"
            :class="{ focus: detailKey===key }"
            v-scroll-to="autoScroll?{ el:'#detailHeader', offset:-80 }:false"
            />
        </g>
      </svg>
      <!-- 新規エリア -->
      <b-container class="ctrl-bar">
        <b-row>
          <b-col>
            <div class="new-area">
              <p>
                <b-button @click="newArea" v-scroll-to="autoScroll?'#name':false" >
                  <font-awesome-icon icon="plus-square" class="icon fa-1x" />
                  エリアを追加
                </b-button>
              </p>
              <p>
                <b-form-checkbox v-model="autoScroll">
                  自動スクロール
                </b-form-checkbox>              
              </p>
            </div>
          </b-col>
          <b-col></b-col>
          <b-col style="text-align: center">
            <div class="move-ctrl" v-if="detailKey">
              <b-container>
                <b-row>
                  <b-col class="p-0"></b-col>
                  <b-col class="p-0">
                    <font-awesome-icon icon="chevron-circle-up" class="icon fa-2x" 
                      @click="moveBy(0, -50)"
                    />
                  </b-col>
                  <b-col class="p-0"></b-col>
                </b-row>
                <b-row>
                  <b-col class="p-0">
                    <font-awesome-icon icon="chevron-circle-left" class="icon fa-2x"
                      @click="moveBy(-50, 0)"
                    />
                  </b-col>
                  <b-col class="p-0"></b-col>
                  <b-col class="p-0">
                    <font-awesome-icon icon="chevron-circle-right" class="icon fa-2x"
                      @click="moveBy(50, 0)"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="p-0"></b-col>
                  <b-col class="p-0">
                    <font-awesome-icon icon="chevron-circle-down" class="icon fa-2x"
                      @click="moveBy(0, 50)"
                    />
                  </b-col>
                  <b-col class="p-0"></b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
        </b-row>
      </b-container>

    </SvgPanZoom>

    <b-form v-if="detailKey">
      <div id="detailHeader"></div>
      <b-form-group id="name" label="エリア名" class="form">
        <b-form-input type="text" v-model="innerValue.area[detailKey].name" 
          :state="nameState" aria-describedby="input-name-help"
        />
        <b-form-invalid-feedback id="input-name-help">
          １字以上１０字以内
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="bg" label="背景" class="form">
        <b-form-input type="text" v-model="innerValue.area[detailKey].bg" debounce="500" />
        <b-img width="250px" height="150px" :src="innerValue.area[detailKey].bg" fluid />
      </b-form-group>
      <b-form-group id="lv" label="エリアレベル" class="form">
        <b-container>
          <b-row>
            <b-col cols="9">
              <b-form-input v-model.number="innerValue.area[detailKey].lv" 
                type="range" min="0" :max="innerValue.world.lv" />
            </b-col>
            <b-col>{{ innerValue.area[detailKey].lv }}</b-col>
          </b-row>          
        </b-container>
      </b-form-group>
      <b-form-group id="link" label="隣接エリア" class="form">
        <b-table-simple small hover>
          <b-thead>
            <b-tr>
              <b-th class="w-50">行先</b-th>
              <b-th class="w-50">条件</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <template v-for="(link,index) in innerValue.area[detailKey].link" >
              <b-tr v-if="innerValue.area[link.to]" :key="index">
                <b-td>
                  <b-button variant="danger" @click="removeLink(index)">
                    <font-awesome-icon icon="times" class="fa-1x" />
                  </b-button>
                  {{ innerValue.area[link.to].name }}
                </b-td>
                <b-td>
                  <b-container>
                    <template v-for="(condVal, cond, index2) in link">
                      <b-row v-if="cond !== 'to'" :key="index2">
                        <b-col>{{ cond }}が{{ condVal }}以上</b-col>
                      </b-row>
                    </template>
                  </b-container>
                </b-td>
              </b-tr>
              <b-tr v-else-if="link.to === 'main'" :key="index">
                <b-td>
                  <b-button variant="danger" @click="removeLink(index)">
                    <font-awesome-icon icon="times" class="fa-1x" />
                  </b-button>
                  不奇跡世界(出口)
                </b-td>
                <b-td>
                  <b-container>
                    <template v-for="(condVal, cond, index2) in link">
                      <b-row v-if="cond !== 'to' && cond !== 'init'" :key="index2">
                        <b-col>{{ cond }}が{{ condVal }}以上</b-col>
                      </b-row>
                    </template>
                  </b-container>
                </b-td>
              </b-tr>
            </template>
            <b-tr>
              <b-td>
                <b-form-select v-model="addLinkKey" :options="areaList" >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>--- 行先を選択 ---</b-form-select-option>
                  </template>
                </b-form-select>
                <b-button @click="addLink">
                  <font-awesome-icon icon="plus-square" class="fa-1x"/>
                  道を追加
                </b-button>
              </b-td>
              <b-td>
                <b-container>
                  <b-row v-for="(cond,index) in linkCondition" :key="index">
                    <b-col cols="1" class="p-0">
                      <b-button class="p-1" @click="$delete(linkCondition, index)">
                        <font-awesome-icon icon="times" class="fa-1x" />
                      </b-button>
                    </b-col>
                    <b-col cols="3" class="p-0"><b-form-input v-model="cond.key" /></b-col>
                    <b-col cols="1" class="p-0">が</b-col>
                    <b-col cols="3" class="p-0"><b-form-input type="number" v-model="cond.value" /></b-col>
                    <b-col cols="2" class="p-0">以上</b-col>
                  </b-row>
                </b-container>
                <b-button @click="linkCondition.push({key:'',value:1})">
                  <font-awesome-icon icon="plus-square" class="fa-1x p-0" />
                  条件を追加
                </b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-form-group>
      <b-form-group id="quest" label="メイン行動" class="form">
        <b-table-simple small hover>
          <b-thead>
            <b-tr>
              <b-th>行動名</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(quest,key) in innerValue.area[detailKey].quest" :key="key">
              <b-td>{{ quest.label }}</b-td>
              <b-td>
                <b-container>
                  <b-row>
                    <b-col>
                      <router-link :to="{ path:`/quest/${detailKey}/${key}` }">
                        <font-awesome-icon icon="pen" class="icon fa-sx" />
                      </router-link>
                    </b-col>
                    <b-col>
                      <a @click="$delete(innerValue.area[detailKey].quest, key)">
                        <font-awesome-icon icon="times" class="icon fa-1x m-1" />
                      </a>
                    </b-col>
                  </b-row>
                </b-container>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                <b-button @click="addMainAction">
                  <font-awesome-icon icon="plus-square" class="fa-1x p-0" />
                  メイン行動を追加
                </b-button>
              </b-td>
              <b-td></b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-form-group>
      <b-form-group id="custom" label="カスタム行動" class="form">
        <b-table-simple small hover>
          <b-thead>
            <b-tr>
              <b-th>行動名</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(quest,key) in innerValue.area[detailKey].custom" :key="key">
              <b-td>{{ quest.label }}</b-td>
              <b-td>
                <b-container>
                  <b-row>
                    <b-col>
                      <a @click="$delete(innerValue.area[detailKey].custom, key)">
                        <font-awesome-icon icon="times" class="icon fa-1x m-1" />
                      </a>
                    </b-col>
                  </b-row>
                </b-container>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-form-group>
      <!-- <b-form-group id="spot" label="帰還スポット" class="form">
        <b-form-checkbox v-model="innerValue.area[detailKey].returnPoint"
          :value="innerValue.area[detailKey].returnPointId" :unchecked-value="'0'"
        >
          帰還スポットを設置する
        </b-form-checkbox>
        <b-form-input type="text" v-if="innerValue.area[detailKey].returnPoint" 
          placeholder="スポット名" 
          v-model="innerValue.area[detailKey].returnPointName" />
      </b-form-group> -->
      <b-form-group id="position" label="配置" class="form">
        (x:{{innerValue.area[detailKey].x}} y:{{innerValue.area[detailKey].y}})
      </b-form-group>

      <b-form-group id="card" label="採取カード" class="form">
        <div style="display: flex; flex-wrap: wrap" class="w-100">
          <b-card v-for="(c,i) in innerValue.area[detailKey].collection" :key="'collection'+i" 
            no-body style="max-width:300px">
            <b-row no-gutters>
              <b-col style="max-width:80px">
                <b-card-img width="80px" height="100px" :src="cardDict[c.key].icon | coalesceCardImage" />
              </b-col>
              <b-col>
                <b-card-body>
                  <b-card-text>
                    {{cardDict[c.key].name}}
                  </b-card-text>
                  <b-form-group label="条件">
                    <div v-for="(v,k) in c.condition" :key="'collection'+i+'condition'+k">
                      {{k}}が{{v}}以上
                    </div>
                  </b-form-group>
                  <b-form-group label="発生確率">
                    <b-input-group append="%">
                      <b-form-input type="number" v-model="c.percent" number />
                    </b-input-group>
                  </b-form-group>
                  <b-button variant="danger" size="sm"
                    @click="innerValue.area[detailKey].collection.splice(i,1)">
                    <b-icon icon="x" />削除
                  </b-button>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
          <b-card bg-variant="info" no-body style="max-width:300px">
            <b-row no-gutters>
              <b-col style="max-width:80px">
                <b-card-img v-if="newCard.key"
                  width="80px" height="100px" :src="cardDict[newCard.key].icon | coalesceCardImage" />
              </b-col>
              <b-col>
                <b-card-body>
                  <b-form-select v-model="newCard.key" 
                    :options="cardList" />
                  <b-form-group label="条件">
                    <div v-for="(v,k) in newCard.condition" :key="'newCondition'+k">
                      <b-button size="sm" variant="danger"
                        @click="$delete(newCard.condition, k)">
                        <b-icon icon="x" class="w-100 h-100 p-0" />
                      </b-button>
                      {{k}}が{{v}}以上
                    </div>
                    <div>
                      <b-input-group>
                        <b-button size="sm"
                          @click="addCardCondition()">
                          <font-awesome-icon icon="plus-square" class="fa-1x p-0" />
                        </b-button>
                        <b-form-input v-model="newCondition.status" />
                        <b-input-group-text class="p-0">≧</b-input-group-text>
                        <b-form-input v-model="newCondition.value" 
                          type="number" number />
                      </b-input-group>
                    </div>
                  </b-form-group>
                  <b-form-group label="発生確率">
                    <b-input-group append="%">
                      <b-form-input type="number" v-model="newCard.percent" number />
                    </b-input-group>
                  </b-form-group>
                  <b-button size="sm"
                    @click="addCollection">
                    <font-awesome-icon icon="plus-square" class="fa-1x p-0" />追加
                  </b-button>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-form-group>

      <b-form-group id="npc" label="NPC" class="form">
        <b-table-simple small hover>
          <b-thead>
            <b-tr>
              <b-th>名前</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(npc,key) in innerValue.area[detailKey].npc" :key="key">
              <b-td>{{ npc.nickname }}</b-td>
              <b-td>
                <b-container>
                  <b-row>
                    <b-col>
                      <router-link :to="{ path:`/npc/${detailKey}/${key}` }">
                        <font-awesome-icon icon="pen" class="icon fa-sx" />
                      </router-link>
                    </b-col>
                    <b-col>
                      <a @click="$delete(innerValue.area[detailKey].npc, key)">
                        <font-awesome-icon icon="times" class="icon fa-1x m-1" />
                      </a>
                    </b-col>
                  </b-row>
                </b-container>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                <b-button @click="newNpc">
                  <font-awesome-icon icon="plus-square" class="fa-1x p-0" />
                  NPCを追加
                </b-button>
              </b-td>
              <b-td></b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-form-group>

      <div class="area-ctrl">
        <div></div>
        <b-button
          :disabled="!innerValue.area[detailKey].entry" 
          variant="danger" @click="remove"
        >
          <font-awesome-icon icon="times" class="icon fa-1x" />
          このエリアを削除
        </b-button>
      </div>

    </b-form>
    <b-button type="button" variant="primary" @click="submit">登録</b-button>
    <response-message ref="response" :value="postMessage" />

  </div>
</template>

<script>
import WorldNav from '@/components/WorldNav'
import SvgPanZoom from 'vue-svg-pan-zoom'
import AreaPoint from './AreaPoint'
import ResponseMessage from '@/components/ResponseMessage'
import _ from 'lodash'
import mixinPlayer from './mixin-player'
import { cards } from './mixin-editor'
export default {
  name: 'Area',
  components: {
    WorldNav,
    SvgPanZoom,
    AreaPoint,
    ResponseMessage
  },
  mixins: [mixinPlayer,cards],
  filters: {
    coalesceCardImage (image) {
      return image || './img/card/front.png'
    }
  },
  computed: {
    areaList () {
      return []
      .concat(_.map(_.keys(this.innerValue.area), (key)=>{
        return { value:key, text:this.innerValue.area[key].name } 
      }),
      [{ value:'main', text:'不奇跡世界(出口)' }])
    },
    nameState () {
      return this.innerValue.area[this.detailKey].name.length > 0
        && this.innerValue.area[this.detailKey].name.length <= 10
    }
  },
  props: {
    value: Object,
    postMessage: Object,
  },
  data () {
    return {
      innerValue: this.value,
      detailKey: null,
      svgpanzoom: null,
      addLinkKey: null,
      linkCondition: [],
      autoScroll: true,
      newCard: {
        key: null,
        condition: {},
        percent: 100
      },
      newCondition: { status:null, value:0 }
    }
  },
  methods: {
    showDetail (value) {
      this.detailKey = value
    },
    newArea () {
      let id = '@'+_.uniqueId()
      let selected = this.innerValue.area[this.detailKey]
      this.$set(this.innerValue.area, id, {
        name: '名の無い大地',
        bg: '',
        lv: 0,
        link: [],
        quest: {
          walk:{
            code: [{
              call: 'totototo.dice',
              arguments: {
                status: "HP",
                up: "EP",
                target: 0
              }
            }],
            prepareCode:[],
            condition:[],
            label: "散歩する",
            location: id,
            RID: 'walk'
          }
        },
        custom: {},
        weather: '',
        temperature: [],
        parent: null,
        indoor: 0,
        description: '',
        eno: null,
        lockEvent: 0,
        x: selected? selected.x+50: 100,
        y: selected? selected.y+50: 100,
        returnPoint: '0',
        returnPointName: '',
        returnPointId: '1',
        entry: 1,
        collection: [],
        npc: {}
      })
      this.detailKey = id
    },
    moveBy (x, y) {
      this.innerValue.area[this.detailKey].x += x
      this.innerValue.area[this.detailKey].y += y
    },
    remove () {
      this.$delete(this.innerValue.area, this.detailKey)
      //リンク
      _.values(this.innerValue.area).forEach((v)=>{
        v.link = _.reject(v.link, { to:this.detailKey })
      })
      //初期位置
      this.innerValue.world.start
        = _.filter(this.innerValue.world.start, _v=>_v!=this.detailKey)
      this.detailKey = null
    },
    removeLink (index) {
      // let to = this.innerValue.area[this.detailKey].link[index].to
      this.$delete(this.innerValue.area[this.detailKey].link, index)
    },
    addLink () {
      if (this.addLinkKey) {
        let val = { to:this.addLinkKey }
        this.linkCondition.forEach((v)=>{
          if(v.key){
            val[v.key] = v.value
          }
        })
        this.innerValue.area[this.detailKey].link.push(val)
        this.addLinkKey = null
        this.linkCondition = []
      }
    },
    addMainAction () {
      let id = '@'+_.uniqueId()
      this.$set(this.innerValue.area[this.detailKey].quest, id ,{
        RID: id,
        code: [{
          call: 'totototo.dice',
          arguments: {
            status: "",
            up: "",
            target: 0
          }
        }],
        prepareCode:[],
        condition:[],
        label: "散歩する",
        location: this.detailKey
      })
      this.$router.push({ path:`/quest/${this.detailKey}/${id}` })
    },
    submit () {
      if(this.detailKey.startsWith('@')){
        this.detailKey = null
      }
      this.$emit('submit')
    },
    registerSvgPanZoom(svgpanzoom) {
        this.svgpanzoom = svgpanzoom
    },
    addCardCondition () {
      if(this.newCondition.status){
        this.newCard.condition[this.newCondition.status] = this.newCondition.value
      }
      this.newCondition = { status:null, value:0 }
    },
    addCollection () {
      this.addCardCondition()
      this.innerValue.area[this.detailKey].collection.push(this.newCard)
      this.newCard = { key:null, condition:{}, percent:100 }
    },
    newNpc () {
      let id = '@'+_.uniqueId()
      this.$set(this.innerValue.area[this.detailKey].npc, id ,{
        RID: id,
        nickname: '名の無いNPC',
        icon: null,
        selectCard: [],
        item: {},
        status: {
          AGI:0,
          DEX:0,
          EP:0,
          HP:5,
          INT:0,
          MND:0,
          STR:0,
          VIT:0
        },
        diceBattle: {
          icon: {
            normal: null
          },
          event: {
            died: null
          },
          performance: {}
        }
      })
      this.$router.push({ path:`/npc/${this.detailKey}/${id}` })
    },
  },
  created () {
    this.$emit('changePlayer', 'n-player')
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  border: 1px solid #000;
  width: calc(100% - 5px);
  height: 500px;
  background-color: #FFF;

  .rt {
    width: 100%;
    height: 100%;
    display: inline-block;

    .focus{
      color: #0F0;
    }
  }
}

.ctrl-bar {
  position: relative;
  top: -120px;
  width: 100%;

  .new-area {
    position: relative;
    top: 10px;
    width: 150px;
    height: 90px;
    border: 1px solid #000;
    background-color: #FFF;
    text-align: center;
  }

  .move-ctrl {
    margin-left: auto;
    margin-right: 0;
    width: 120px;
    height: 110px;
    border: 1px solid #000;
    background-color: #FFF;

    .icon {
      cursor: pointer;
      color: #FC0;

      :hover {
        color: #C90;
      }
    }
  }

}

.form {
  border: 5px solid #EEE;
  padding: 5px;
}
.area-ctrl {
  display: flex;
  justify-content: space-between;
}

</style>
